import type { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';

import { userActions } from '@/entities/user';
import { extractApiError } from '@/shared/lib/api/extractError';

import { withdrawApi } from '../api/withdrawApi';
import { withdrawActions } from './slice';
import type { WithdrawalRequest } from './types';

function* submitWithdrawSaga(
  action: PayloadAction<{ amount: number; wallet: string }>,
): Generator {
  yield put(withdrawActions.setSubmitting(true));
  yield put(withdrawActions.resetStatus());
  try {
    const { amount, wallet } = action.payload;
    const result = (yield call(withdrawApi.postWithdraw, amount, wallet)) as WithdrawalRequest;
    yield put(withdrawActions.submitSuccess(result));
    yield put(userActions.fetchUserRequest());
  } catch (err) {
    yield put(withdrawActions.submitFailure(extractApiError(err)));
  }
}

function* fetchHistorySaga(): Generator {
  yield put(withdrawActions.setHistoryLoading(true));
  try {
    const history = (yield call(withdrawApi.getWithdrawalHistory)) as WithdrawalRequest[];
    yield put(withdrawActions.setHistory(history));
  } catch {
    yield put(withdrawActions.setHistoryLoading(false));
  }
}

export function* withdrawWatcher(): Generator {
  yield takeLatest(withdrawActions.submitRequest.type, submitWithdrawSaga);
  yield takeLatest(withdrawActions.fetchHistoryRequest.type, fetchHistorySaga);
}
